import { render, staticRenderFns } from "./DocumentCardSales.vue?vue&type=template&id=b7604f48&scoped=true"
import script from "./DocumentCardSales.vue?vue&type=script&lang=js"
export * from "./DocumentCardSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7604f48",
  null
  
)

export default component.exports